import { Component } from "@/types/types"
import { cx } from "@/utils/cx"
import NextLink from "next/link"

export const COMPONENT_NAME = "link"

export const presets = {}

export interface Props extends Component {
  href: string
  disabled?: boolean
  newTab?: boolean
  tabIndex?: number
  ariaLabel?: string
  onClick?: () => void
  index?: number
  prefetch?: boolean
}

export function Link({
  href,
  newTab = false,
  disabled = false,
  ariaLabel,
  onClick,
  children,
  tabIndex,
  prefetch = true,
  className,
  testId = COMPONENT_NAME,
  index,
}: Props) {
  const hasExternalHref = href.startsWith(`/`) === false
  const target = newTab || hasExternalHref ? `_blank` : undefined
  const rel = newTab || hasExternalHref ? `noopener noreferrer` : undefined

  return (
    <NextLink
      href={href}
      className={cx(disabled && "pointer-events-none focus:outline-none", className)}
      tabIndex={disabled ? -1 : tabIndex}
      target={target}
      rel={rel}
      prefetch={hasExternalHref ? false : prefetch}
      data-test={testId}
      aria-label={ariaLabel}
      onClick={onClick}
      data-index={index}
    >
      {children}
    </NextLink>
  )
}
